export const AccountStatus = {
	RegistrationNotComplete: 'registrationNotComplete',
	Restricted: 'restricted',
	Normal: 'normal',
	Closed: 'closed',
	Locked: 'locked',
	Unknown: 'unknown',
	Pending: 'pending',
	Inactive: 'inactive',
	Closing: 'closing',
} as const;

export type AccountStatusType = (typeof AccountStatus)[keyof typeof AccountStatus];

export const NextStep = {
	ContactSupport: 'contactSupport',
	SpendDown: 'spendDown',
	ClaimFunds: 'claimFunds',
	None: 'none',
	ReactivateAccount: 'reactivateAccount',
	TransferIn: 'transferIn',
} as const;

export type NextStepType = (typeof NextStep)[keyof typeof NextStep];

export const TransactionCategoriesTypes = {
	Groceries: 'groceries',
	Food: 'food',
	Transportation: 'transportation',
	Shopping: 'shopping',
	Bills: 'bills',
	Entertainment: 'entertainment',
	Miscellaneous: 'miscellaneous',
} as const;

export type TransactionCategoriesType =
	(typeof TransactionCategoriesTypes)[keyof typeof TransactionCategoriesTypes];

export const TransactionTileTypes = {
	StockBackReward: 'stockBackReward',
} as const;

export type TransactionTileType = (typeof TransactionTileTypes)[keyof typeof TransactionTileTypes];
